import React, { Fragment, useEffect } from 'react'
import PinInput from 'react-pin-input'
import GeneralInputMask from '../../../../../components/GeneralInputMask'
import Ticker from './Ticker'
import './style.scss'

const CreditPhoneValidation = ({
  error,
  codeSms,
  setPinCode,
  phone,
  emptyPhone,
  handleWithPinValidation,
  handleWithResendSMS,
  handleSendSMS,
}) => {
  const useMountEffect = (fun) => useEffect(fun, [])

  useMountEffect(handleWithResendSMS)

  return (
    <Fragment>
      {codeSms && (
        <Fragment>
          {emptyPhone ? (
            <div className='phone_validation_number'>
              {Boolean(error) && (
                <p style={{ color: 'red', textAlign: 'center', margin: 16 }}>{error}</p>
              )}
              <GeneralInputMask
                handleChange={phone}
                mask={[
                  '(',
                  /\d/,
                  /\d/,
                  ')',
                  ' ',
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                  '-',
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                ]}
                label='Telefone'
              />
              <button className='phone_validation_button' onClick={handleSendSMS}>
                Enviar Código
              </button>
            </div>
          ) : (
            <Fragment>
              {Boolean(error) && (
                <p style={{ color: 'red', textAlign: 'center', margin: 16 }}>{error}</p>
              )}
              <div className='phone_validation_header'>
                <div className='phone_validation_title'>Enviamos um código SMS</div>
                <div className='phone_validation_title'>por favor insira ele abaixo:</div>
              </div>
              <div className='phone_validation_content'>
                <div>
                  <PinInput length={4} focus type='numeric' onChange={setPinCode} />
                </div>
              </div>
              <div className='phone_validation_footer'>
                <span className='phone_validation_button' onClick={handleWithPinValidation}>
                  Confirmar Código
                </span>
                <Ticker handleWithResendSMS={() => handleWithResendSMS()} />
              </div>
            </Fragment>
          )}
        </Fragment>
      )}
    </Fragment>
  )
}

// TODO: use ts
// CreditPhoneValidation.propTypes = {
//   codeSms: PropTypes.bool,
//   error: PropTypes.string,
//   setPinCode: PropTypes.func,
//   phone: PropTypes.func,
//   emptyPhone: PropTypes.bool,
//   handleWithPinValidation: PropTypes.func,
//   handleWithResendSMS: PropTypes.func,
//   handleSendSMS: PropTypes.func,
// }

export default CreditPhoneValidation
